export default __webpack_public_path__ + "static/media/Glodani 5.2e5de460.jpg";